/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NgBuilderDirective as ɵa} from './lib/ng-builder.directive';